import { Component, Input, OnInit, ChangeDetectionStrategy, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-cr-avatar',
  templateUrl: './cr-avatar.component.html',
  styleUrls: ['./cr-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CrAvatarComponent implements OnInit, OnChanges {
  @Input() userName: string = '';
  @Input() theme: 'THEME-1' | 'THEME-2' = 'THEME-1';
  @Input() size: 'S' | 'M' | 'L' = 'S';

  public initials: string = '';

  get sizeClass(): string {
    const sizeNominator = this.size || 'S';
    return `size-${sizeNominator.toLowerCase()}`;
  }

  ngOnInit(): void {
    this.initials = this.getInitials(this.userName);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userName'] && !changes['userName'].firstChange) {
      this.initials = this.getInitials(this.userName);
    }
  }

  private getInitials(name: string): string {
    if (!name || name.trim().length === 0) {
      return '';
    }

    const trimmedName = name.trim();
    const words = trimmedName.split(' ').filter(word => word.length > 0);

    if (words.length === 0) {
      return '';
    }

    if (words.length === 1) {
      // Single word - take first and last letter
      const word = words[0];
      const firstLetter = word.charAt(0).toUpperCase();
      const lastLetter = word.charAt(word.length - 1).toUpperCase();
      return firstLetter + lastLetter;
    }

    // Multiple words - take first letter of first and last word
    const firstInitial = words[0].charAt(0).toUpperCase();
    const lastInitial = words[words.length - 1].charAt(0).toUpperCase();

    return firstInitial + lastInitial;
  }
}
